import { Form } from "@client/content/controls";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo } from "@client/controls/Form/component";
import * as React from "react";
import ResetPasswordButton from "./Button";

export type MapProps = RootContainerProps & {
  fields: FormFieldInfo[];

  alert: string | null;
  error: string | null;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Form
    {...getRootContainerProps(props)}
    fields={props.fields}
    Button={ResetPasswordButton}
    buttonProps={getRootContainerProps(props)}
    error={props.error}
  />
);
